import { render, staticRenderFns } from "./BottombarPartial.vue?vue&type=template&id=73472bae&scoped=true&"
import script from "./BottombarPartial.vue?vue&type=script&lang=js&"
export * from "./BottombarPartial.vue?vue&type=script&lang=js&"
import style0 from "./BottombarPartial.vue?vue&type=style&index=0&id=73472bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73472bae",
  null
  
)

export default component.exports